export default __webpack_public_path__ + "static/tech-googleworkspace-f57cb6efe1e92d4a634c38f81f01a577-f57cb6efe1e92d4a634c38f81f01a577.png";